import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setDictionarySortAction,
  toggleAllDictionarySelectionsAction,
} from '../../redux/slices/dictionary';
import { Order } from '../../utils/apollo/graphqlSchema';
import { HeaderLabel } from './FormHeadersUI';
import SortableHeaderLabel from './SortableHeaderLabel';
import { DictionaryTypeEnum, SortingKindEnum } from '../../utils/interfaces';
import TickCheckbox from '../../components/Checkbox/TickCheckbox';
import { RootState } from '../../redux/store';

interface IProps {
  dictionaryType: DictionaryTypeEnum;
  headerObject: any;
}
export default ({ dictionaryType, headerObject }: IProps) => {
  const dispatch = useDispatch();
  const sortingConfig = useSelector(
    (state: RootState) => state.dictionary.sortingConfigs[dictionaryType],
  );

  const dictionaryItems = useSelector(
    (state: RootState) => state.dictionary[dictionaryType],
  );

  const selections = useSelector(
    (state: RootState) => state.dictionary.selections,
  );

  const toggleSortLabel = (colIndex: number, sortKind: string) => {
    const newSortType =
      sortingConfig.sortingType === Order.Asc ? Order.Desc : Order.Asc;

    dispatch(
      setDictionarySortAction({
        dictionaryType,
        value: newSortType,
        index: colIndex,
        sortKind,
      }),
    );
  };

  const toggleSelections = () => {
    dispatch(
      toggleAllDictionarySelectionsAction({
        dictionaryType,
      }),
    );
  };

  return headerObject.map(
    (
      { col: columnName, text, sortable, align, sortKind }: any,
      index: number,
    ) => {
      if (columnName === 'checkbox') {
        return (
          <TickCheckbox
            key={columnName}
            type="checkbox"
            checked={
              selections.length !== 0 &&
              dictionaryItems.length === selections.length
            }
            onClick={toggleSelections}
          />
        );
      }

      if (!text) {
        return <div key={columnName} />;
      }

      const shouldAlignRight = align === 'right';

      if (!sortable) {
        return (
          <HeaderLabel key={columnName} $isRightAlignment={shouldAlignRight}>
            {text}
          </HeaderLabel>
        );
      }

      const isCurrentSortingKindActive = sortingConfig.sortingKey === sortKind;
      const activeSortType = sortingConfig.sortingType;

      return (
        <SortableHeaderLabel
          key={columnName}
          onClick={() => toggleSortLabel(index, sortKind)}
          activeSortType={activeSortType}
          text={text}
          isActive={isCurrentSortingKindActive}
          shouldAlignRight={shouldAlignRight}
          showTimeZone={
            sortKind === SortingKindEnum.DATE ||
            sortKind === SortingKindEnum.CREATION_DATE ||
            sortKind === SortingKindEnum.EDIT_DATE ||
            sortKind === SortingKindEnum.LAST_LOGIN
          }
        />
      );
    },
  );
};
